module.exports = __webpack_public_path__ + "static/media/fd-loader.ccbdfc55.gif";